export function getMinimum<T>(
  items: T[],
  picker: (item: T) => string | number = (item) => item as any
) {
  if (!items.length) {
    return;
  }

  let min = items[0];

  items.forEach((item) => {
    if (picker(item) < picker(min)) {
      min = item;
    }
  });

  return min;
}
